<span class="block">
  <button
    mat-icon-button
    [matTooltip]="tooltip"
    [matTooltipPosition]="tooltipPosition"
    type="button"
    [disabled]="disabled"
    class="manage-post-btn border border-gray-300"
    [ngClass]="buttonClass"
    (click)="handleClick()"
  >
    <mat-icon>{{ icon }}</mat-icon>
  </button>
</span>